import React, { Component } from 'react';
import './Works.scss';

class Works extends Component {
  render() {
    return (
      <section id="works" className="works section no-padding">
        <div className="container-fluid">
          <div className="row no-gutter">
            <div className="col-lg-3 col-md-6 col-sm-6 work">
              <a href="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/intermediary/f/0bd4b444-7ee3-495e-bc15-af3ebaed4df2/dc0f4bb-0e460ef8-32db-41ff-8df7-96d40bcaa6e1.png/v1/fill/w_1789,h_447,q_70,strp/lng_carrier_by_denisdrakulla_dc0f4bb-pre.jpg" className="work-box">
                <img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/intermediary/f/0bd4b444-7ee3-495e-bc15-af3ebaed4df2/dc0f4bb-0e460ef8-32db-41ff-8df7-96d40bcaa6e1.png/v1/fill/w_1789,h_447,q_70,strp/lng_carrier_by_denisdrakulla_dc0f4bb-pre.jpg" alt="" />
                <div className="overlay">
                  <div className="overlay-caption">
                    <h5>LNG Carrier</h5>
                    <p>Click to expand</p>
                  </div>
                </div>
              </a>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 work">
              <a href="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/intermediary/f/0bd4b444-7ee3-495e-bc15-af3ebaed4df2/dcpz5o7-d09f5372-ef2f-4a0b-a812-64cbf0ecc60f.png/v1/fill/w_1490,h_536,q_70,strp/stylized_character_lumberjack_by_denisdrakulla_dcpz5o7-pre.jpg" className="work-box">
                <img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/intermediary/f/0bd4b444-7ee3-495e-bc15-af3ebaed4df2/dcpz5o7-d09f5372-ef2f-4a0b-a812-64cbf0ecc60f.png/v1/fill/w_1490,h_536,q_70,strp/stylized_character_lumberjack_by_denisdrakulla_dcpz5o7-pre.jpg" alt="" />
                <div className="overlay">
                  <div className="overlay-caption">
                    <h5>Stylized character lumberjack</h5>
                    <p>Click to expand</p>
                  </div>
                </div>
              </a>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 work">
              <a href="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/intermediary/f/0bd4b444-7ee3-495e-bc15-af3ebaed4df2/dcpz58p-005732eb-cb95-4886-a968-ea8291cebd05.png/v1/fill/w_1032,h_774,q_70,strp/stylized_police_car_by_denisdrakulla_dcpz58p-pre.jpg" className="work-box">
                <img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/intermediary/f/0bd4b444-7ee3-495e-bc15-af3ebaed4df2/dcpz58p-005732eb-cb95-4886-a968-ea8291cebd05.png/v1/fill/w_1032,h_774,q_70,strp/stylized_police_car_by_denisdrakulla_dcpz58p-pre.jpg" alt="" />
                <div className="overlay">
                  <div className="overlay-caption">
                    <h5>Stylized Police Car</h5>
                    <p>Click to expand</p>
                  </div>
                </div>
              </a>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 work">
              <a href="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/intermediary/f/0bd4b444-7ee3-495e-bc15-af3ebaed4df2/dcemkoa-03ee89e1-662c-428e-bcc5-0eadb8aa26d2.png/v1/fill/w_1460,h_547,q_70,strp/crazy_bee_by_denisdrakulla_dcemkoa-pre.jpg" className="work-box">
                <img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/intermediary/f/0bd4b444-7ee3-495e-bc15-af3ebaed4df2/dcemkoa-03ee89e1-662c-428e-bcc5-0eadb8aa26d2.png/v1/fill/w_1460,h_547,q_70,strp/crazy_bee_by_denisdrakulla_dcemkoa-pre.jpg" alt="" />
                <div className="overlay">
                  <div className="overlay-caption">
                    <h5>Crazy Bee</h5>
                    <p>Click to expand</p>
                  </div>
                </div>
              </a>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 work">
              <a href="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/intermediary/f/0bd4b444-7ee3-495e-bc15-af3ebaed4df2/dcpz52x-f8fd87b9-5921-4a92-82f7-cec0a539a1e1.png/v1/fill/w_1032,h_774,q_70,strp/tow_truck_by_denisdrakulla_dcpz52x-pre.jpg" className="work-box">
                <img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/intermediary/f/0bd4b444-7ee3-495e-bc15-af3ebaed4df2/dcpz52x-f8fd87b9-5921-4a92-82f7-cec0a539a1e1.png/v1/fill/w_1032,h_774,q_70,strp/tow_truck_by_denisdrakulla_dcpz52x-pre.jpg" alt="" />
                <div className="overlay">
                  <div className="overlay-caption">
                    <h5>Tow truck</h5>
                    <p>Click to expand</p>
                  </div>
                </div>
              </a>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 work">
              <a href="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/intermediary/f/0bd4b444-7ee3-495e-bc15-af3ebaed4df2/dc1mvht-c205ceb2-d119-42d4-b1e6-aa5cb64be7c3.png/v1/fill/w_1847,h_433,q_70,strp/pigpen_by_denisdrakulla_dc1mvht-pre.jpg" className="work-box">
                <img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/intermediary/f/0bd4b444-7ee3-495e-bc15-af3ebaed4df2/dc1mvht-c205ceb2-d119-42d4-b1e6-aa5cb64be7c3.png/v1/fill/w_1847,h_433,q_70,strp/pigpen_by_denisdrakulla_dc1mvht-pre.jpg" alt="" />
                <div className="overlay">
                  <div className="overlay-caption">
                    <h5>Pigpen</h5>
                    <p>Click to expand</p>
                  </div>
                </div>
              </a>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 work">
              <a href="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/intermediary/f/0bd4b444-7ee3-495e-bc15-af3ebaed4df2/dbptduu-aeb2c2e4-5a50-4fd1-8f7c-424951a6f757.png/v1/fill/w_1192,h_670,q_70,strp/food_by_denisdrakulla_dbptduu-pre.jpg" className="work-box">
                <img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/intermediary/f/0bd4b444-7ee3-495e-bc15-af3ebaed4df2/dbptduu-aeb2c2e4-5a50-4fd1-8f7c-424951a6f757.png/v1/fill/w_1192,h_670,q_70,strp/food_by_denisdrakulla_dbptduu-pre.jpg" alt="" />
                <div className="overlay">
                  <div className="overlay-caption">
                    <h5>Castle on the hill</h5>
                    <p>Click to expand</p>
                  </div>
                </div>
              </a>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 work">
              <a href="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/intermediary/f/0bd4b444-7ee3-495e-bc15-af3ebaed4df2/dco5mke-36e9e950-0ace-4bd7-b025-2eb577c01871.png/v1/fill/w_1024,h_768,q_80,strp/coffe_truck_by_denisdrakulla_dco5mke-fullview.jpg" className="work-box">
                <img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/intermediary/f/0bd4b444-7ee3-495e-bc15-af3ebaed4df2/dco5mke-36e9e950-0ace-4bd7-b025-2eb577c01871.png/v1/fill/w_1024,h_768,q_80,strp/coffe_truck_by_denisdrakulla_dco5mke-fullview.jpg" alt="" />
                <div className="overlay">
                  <div className="overlay-caption">
                    <h5>Coffe truck</h5>
                    <p>Click to expand</p>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Works;